import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import { APPEARANCES, SIZES } from './constants';
const Tag = ({
  iconGlyph = undefined,
  iconStrokeWidth = 2,
  appearance = APPEARANCES.accent,
  label = '',
  isLabelBold = false,
  size = SIZES.medium,
  onClick = undefined,
}) => {
  const classes = classNames('ws-ui-tag', `ws-ui-tag--${size}`, `ws-ui-tag--${appearance}`, {
    'ws-ui-tag--with-icon': iconGlyph && label,
    'ws-ui-tag--only-icon': iconGlyph && !label,
    'ws-ui-tag--with-hover': onClick,
  });

  return (
    <div className={classes} {...(onClick && { onClick })}>
      {iconGlyph && (
        <span className="ws-ui-tag__icon">
          <Icon glyph={iconGlyph} type="inherit" size="100%" strokeWidth={iconStrokeWidth} />
        </span>
      )}
      {label && <span className="ws-ui-tag__text">{isLabelBold ? <b>{label}</b> : label}</span>}
    </div>
  );
};

export default Tag;
